import {
  getKnowledgeTagKey,
  type ISelectedKnowledgeTagData,
} from '../KnowledgeBaseMention/components/SelectedKnowledgeTag';

/** 知识库 mention 稳定 key（避免 editorDom 循环依赖） */
export function buildKnowledgeMentionKey(
  items: ISelectedKnowledgeTagData[],
): string {
  if (!items.length) return `knowledge:${Date.now()}`;
  const ids = [...items].map((item) => getKnowledgeTagKey(item)).sort().join('_');
  return `knowledge:${ids}`;
}
